import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import '../styles/CommonText.css';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <> {/* Usiamo un Fragment per avvolgere tutto */}
      <Helmet>
        <title>Just4Fun ITA Community</title>
        <meta name="description" content="Il punto di ritrovo per giocatori, Youtubers e appassionati che vogliono divertirsi insieme." />
        {/* Qui Google leggerà le info corrette */}
      </Helmet>

      <div className="home-page">
        <div className="home-container">
          {/* Hero Section */}
          <header className="home-header">
            <h1 className='titolo-principale'>Benvenuti nella community Just4Fun!</h1>
            <p className='descrizione-hero'>Il punto di ritrovo per giocatori, Youtubers e appassionati che vogliono divertirsi insieme.</p>
          </header>

          <div className="hero-buttons">
            <Link to="/servizi" className="btn-custom-orange">I Nostri Servizi</Link>
            <a href="https://discord.just4fun.it" target="_blank" rel="noopener noreferrer" className="btn-custom-discord">Entra in Discord</a>
          </div>

          {/* Features Principali */}
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎮</div>
              <h3>Gaming & Fun</h3>
              <p>Una community attiva dove trovare nuovi compagni di gioco e partecipare ad eventi dedicati al divertimento.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📢</div>
              <h3>Social News</h3>
              <p>Fai crescere il tuo canale YouTube o Twitch grazie alle notifiche automatiche del nostro Bot.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🛠️</div>
              <h3>Supporto & Help</h3>
              <p>I nostri sviluppatori offrono assistenza dedicata per i servizi Just4Fun e supporto tecnico generale.</p>
            </div>
          </div>

          {/* --- NUOVA SEZIONE: Focus sul Bot --- */}
          <section className="bot-highlight-section">
            <div className="bot-highlight-content">
              <h2 className="titolo-sezione">Just4Fun APP</h2>
              <div className="mission-content">
                <p>Il nostro Bot Discord ufficiale è disponibile per la tua community. Offriamo sistemi di notifiche social e comandi personalizzati.</p>
              </div>
              <Link to="/j4f-app" className="btn-custom-discord">Scopri il Bot</Link>
            </div>
          </section>

          <div className="separator"></div>

          {/* --- SEZIONE: Chi Siamo --- */}
          <section className="mission-section landing-block">
            <h2 className="titolo-sezione">Perché scegliere Just4Fun?</h2>
            <div className="mission-content">
              <p>
                Just4Fun è il luogo ideale per chi cerca una community sana dove giocare e stare in compagnia. 
                Crediamo che il divertimento sia più bello se condiviso: che tu voglia trovare nuovi compagni di squadra 
                o semplicemente un posto dove chiacchierare, qui troverai sempre qualcuno pronto a darti il benvenuto. 
              </p>
            </div>
          </section>

          {/* --- SEZIONE: Collaboratori (Box dedicato) --- */}
          <section className="collaboratori-section landing-block">
            <div className="collaboratori-box highlight-box">
              <h2 className="titolo-sezione">Programma Collaboratori & Community</h2>
              <p>
                Crediamo fortemente nelle sinergie. Abbiamo sviluppato un ramo dedicato ai <strong>collaboratori </strong> 
                e alle <strong>altre community</strong> che desiderano crescere insieme a noi. 
              </p>
              <ul className="collaboratori-list">
                <li><strong>Servizi Esclusivi:</strong> Strumenti avanzati di gestione e visibilità.</li>
                <li><strong>Supporto alla Crescita:</strong> Assistenza strategica per Creator e Streamer.</li>
                <li><strong>Vantaggi Competitivi:</strong> Soluzioni tecniche a condizioni vantaggiose.</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Home;